import { apiRequest } from "./api";
import { addExtraCities } from "./cities";

/* The cities an admin added (mock City_1), joined to the app's lists at start: the copy
   kept from the last visit at once, then the server's. No account needed; nothing about
   the visitor is sent. */
const KEY = "sramika_extra_cities";

export function loadExtraCities() {
  try { addExtraCities(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch { /* storage blocked */ }
  return apiRequest("/config/cities")
    .then((r) => {
      const list = Array.isArray(r?.data) ? r.data : [];
      addExtraCities(list);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch { /* storage blocked */ }
      return list;
    })
    .catch(() => []);
}
